<!-- 解锁接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885S",
          "channelId": 123,
          "newCarNo": "粤Y12345",
          "correctTime": "20200413112200"
        },
        responseCode:{"data":{}, "message": "业务成功", "resultCode": 0, "status": 1},
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台对指定车场的进出车确认拍照后进行车牌校正",
          t_url: this.commonUrls.test+"correctingCarCodeAfterCarInOutConfirmPhone",
          p_url: this.commonUrls.prod+"correctingCarCodeAfterCarInOutConfirmPhone",
          precondition: "无",
          fitSystem: "云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'channelId', info2: '是', info3: 'Integer', info4: '通道ID' },
              { info1: 'recordType', info2: '否', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发），默认值1' },
              { info1: 'newCarNo', info2: '是', info3: 'String', info4: '校正后车牌' },
              { info1: 'carType', info2: '否', info3: 'Integer', info4: '校正后车牌颜色：1蓝牌车，2黄牌车，3新能源大车，4新能源小车 默认值1' },
              { info1: 'correctTime', info2: '是', info3: 'String', info4: '校正时间，格式：yyyyMMddHHmmss' },
              { info1: 'correctName', info2: '否', info3: 'String', info4: '校正操作人' },
              { info1: 'correctMethod', info2: '否', info3: 'Integer', info4: '校正方式（0未知，1手动校正，2人工匹配，3模糊匹配，4车牌强转，5自动校正），默认值0' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/correctingCarCodeAfterCarInOutConfirmPhone.vue